'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var uaParserJs = require('ua-parser-js');
var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var BOT_UA = [
    '\\+https:\\/\\/developers.google.com\\/\\+\\/web\\/snippet\\/',
    'googlebot',
    'baiduspider',
    'gurujibot',
    'yandexbot',
    'slurp',
    'msnbot',
    'bingbot',
    'facebookexternalhit',
    'linkedinbot',
    'twitterbot',
    'slackbot',
    'telegrambot',
    'applebot',
    'pingdom',
    'tumblr',
];

/**
 * Get the information of an useragent string.
 *
 * @param phrase user agent strings.
 * @returns parsed information.
 */
function parse(phrase) {
    var result = new uaParserJs.UAParser(phrase).getResult();
    var regex = new RegExp("(" + BOT_UA.join('|') + ")", 'ig');
    var isBot = phrase ? regex.test(phrase.toLowerCase()) : false;
    var browser = result.browser.name;
    var deviceType = result.device.type || null;
    var os = result.os.name;
    var engine = result.engine.name;
    var isMobile = deviceType === 'mobile';
    var isTablet = deviceType === 'tablet';
    var isIos = os === 'iOS';
    var ua = Object.freeze({
        browser: browser,
        deviceType: deviceType,
        os: os,
        engine: engine,
        isMobile: isMobile,
        isTablet: isTablet,
        isIos: isIos,
        source: phrase,
        deviceVendor: result.device.vendor || null,
        osVersion: parseInt(result.os.version, 10),
        browserVersion: parseFloat(result.browser.version),
        engineVersion: parseFloat(result.engine.version),
        isIphone: isMobile && isIos,
        isIpad: isTablet && isIos,
        isDesktop: !isMobile && !isTablet,
        isChrome: browser === 'Chrome',
        isFirefox: browser === 'Firefox',
        isSafari: browser === 'Safari',
        isIE: browser === 'IE',
        isEdge: browser === 'Edge',
        isOpera: browser === 'Opera',
        isMac: os === 'Mac OS',
        isChromeOS: os === 'Chromium OS',
        isWindows: os === 'Windows',
        isAndroid: os === 'Android',
        isBot: isBot,
    });
    return ua;
}

function useUserAgent(phase) {
    return parse(phase);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/* tslint:disable: variable-name */
function withUserAgent(ComposedComponent) {
    var _this = this;
    var name = ComposedComponent.displayName || ComposedComponent.name;
    var ua;
    var WithUserAgentWrapper = /** @class */ (function (_super) {
        __extends(WithUserAgentWrapper, _super);
        function WithUserAgentWrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithUserAgentWrapper.prototype.render = function () {
            if (!ua && typeof window !== 'undefined') {
                ua = parse(window.navigator.userAgent);
            }
            return (React__namespace.createElement(ComposedComponent, __assign({ ua: ua }, this.props)));
        };
        WithUserAgentWrapper.displayName = "withUserAgent(" + name + ")";
        return WithUserAgentWrapper;
    }(React__namespace.Component));
    if (ComposedComponent.getInitialProps) {
        WithUserAgentWrapper.getInitialProps = function (context) { return __awaiter(_this, void 0, void 0, function () {
            var initialProps, uaString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        initialProps = {};
                        uaString = '';
                        if (typeof context.req !== 'undefined') {
                            uaString = context.req.headers['user-agent'];
                        }
                        else if (typeof window !== 'undefined') {
                            uaString = window.navigator.userAgent;
                        }
                        ua = parse(uaString);
                        context.ua = Object.assign({}, ua);
                        return [4 /*yield*/, ComposedComponent.getInitialProps(context)];
                    case 1:
                        initialProps = _a.sent();
                        if (context.ua) {
                            delete context.ua;
                        }
                        return [2 /*return*/, initialProps];
                }
            });
        }); };
    }
    return WithUserAgentWrapper;
}

exports.parse = parse;
exports.useUserAgent = useUserAgent;
exports.withUserAgent = withUserAgent;
